import React, {Component} from 'react';
import './fault.scss';

import nodata from '../../assets/nodata.png';

export default
class Error404 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {

  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  // shouldComponentUpdate() {
  //
  // }

  render() {
    return (
      <div className="no-data">
        <img src={nodata} alt=""/>
        <p>页面不存在~</p>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/Fault/fault.js